module.exports = __webpack_public_path__ + "static/media/TotalActive.b446a8f5.svg";